<template>
  <div class="booking">
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive"> </router-view>
    </keep-alive>

    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive"> </router-view>
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi";

export default {
  watch: {
    $route: {
      handler(newVal) {
        if (dd.env.platform !== "notInDingTalk") {
          dd.biz.navigation.setTitle({
            title: newVal.meta.title, //控制标题文本，空字符串表示显示默认文本
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.booking {
  height: 100%;
  background: url("./../../assets/images/booking/bg.png");
  background-size: 100% 100%;
  font-family: Noto Sans SC-Medium, Noto Sans;
  color: #040000;
  overflow: auto;
  max-width: 450px;
  margin: 0 auto;
  .van-cell--required::before {
    color: #da0032;
  }
  .van-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.booking-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  font-size: 15px;
  & > div {
    cursor: pointer;
  }
}
.booking-submit {
  color: #da0032;
}
.booking-form {
  .van-cell {
    background-color: transparent;
    padding: 15px 20px;
  }
  .booking-form-select {
    color: #040000;

    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .van-cell::after {
    left: 0;
    right: 0;
  }
  .van-field__label {
    color: #040000;

    font-size: 15px;
  }
  .van-checkbox__label {
    color: #040000;
  }
  .van-field__control {
    &::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #040000;
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #040000;
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #040000;
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #040000;
    }
  }
  .booking-placeholder-gray {
    .van-field__control {
      &::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: rgba(4, 0, 0, 0.5);
      }
      &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: rgba(4, 0, 0, 0.5);
      }
      &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: rgba(4, 0, 0, 0.5);
      }
      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: rgba(4, 0, 0, 0.5);
      }
    }
  }
}
.booking-division {
  height: 6px;
  opacity: 0.4;
  background: #eaeaea;
}

.booking-form-hide-input {
  .van-field__control {
    // visibility: hidden;
    display: none;
  }
  .van-field__button {
    flex: 1;
  }
}
.booking-label {
  position: relative;
  padding: 6px 15px;
  border-radius: 50px;
  background-color: #fff;
  display: block;
  z-index: 2;
  //   box-shadow: 0px 5px 15px 0px rgba(228, 99, 94, 0.13);
}
.booking-label::before {
  content: " ";
  display: block;
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  border-radius: 50px;
  background: #fff;
  z-index: -1;
}
.booking-label::after {
  content: " ";
  display: block;
  position: absolute;
  top: -2px;
  right: -2px;
  bottom: -2px;
  left: -2px;
  border-radius: 50px;
  background: linear-gradient(90deg, rgba(0, 45, 93, 1), rgba(218, 0, 50, 1));
  z-index: -2;
}
.booking-collect-dialog {
  .el-dialog {
    border-radius: 20px;
  }
  .el-dialog__header {
    padding: 0;
  }
}
</style>